import { createContext, useContext, useReducer  } from 'react'

const LoadingContext = createContext()

const useLoading = () => {
    const context = useContext(LoadingContext)

    if (context === undefined) throw new Error('useLoading must be used within a LoadingProvider')

    return context
}

const LoadingProvider = ({ children }) => {
    const reducer = (state, { name, payload }) => {
        return { ...state, [name]: payload }
    }

    const [$state, dispatch] = useReducer(reducer, {})

    const set = (name, payload) => dispatch({ name, status: payload })
    const start = (name) => set(name, true)
    const end = (name) => set(name, false)

    return (
        <LoadingContext.Provider value={{ $state, set, start, end }}>
            {children}
        </LoadingContext.Provider>
    )
}

export { useLoading, LoadingProvider }